import { render, staticRenderFns } from "./ProductInfoItemLoop.vue?vue&type=template&id=3219a4eb&"
import script from "./ProductInfoItemLoop.vue?vue&type=script&lang=js&"
export * from "./ProductInfoItemLoop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports